import { useEffect, useState } from "react";
import backendApi from "../api/backendApi";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import AlertModal from "../components/modal/AlertModal";
import LoadingButton from "../components/LoadingButton";

const EmailSentPage = () => {
  const timerDuration = 60;
  const [timer, setTimer] = useState(timerDuration);
  const [disabled, setDisabled] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [title, setTitle] = useState("");
  const location = useLocation();
  const [email] = useState(location.state?.email);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [timer]);

  if (!email) {
    return <Navigate to="/auth" replace />;
  }

  const handleResend = async () => {
    try {
      setSubmitting(true);
      await backendApi.post("/auth/resend-email", { email });
      setTitle("Email Sent!");
      setModalMessage("Email resent successfully.");
      setIsSuccess(true);
      setModalOpen(true);
    } catch (err) {
      console.error("Resend failed:", err);
      setTitle("Failed to resend email");
      setModalMessage("Please try again later.");
      setModalOpen(true);
      setIsSuccess(false);
    }
  };

  return (
    <div className="flex w-full h-full items-center justify-center p-4 bg-white">
      <div className="shadow rounded text-center p-6">
        <h2 className="text-2xl font-bold mb-4">Email Sent!</h2>
        <p className="mb-4">
          We've sent a temporary password to <strong>{email}</strong>. <br />
          Please check your inbox and log in using the credentials provided.
        </p>
        <LoadingButton
          variant="plain"
          onClick={handleResend}
          loading={submitting}
          className={`px-4 py-2 rounded ${
            disabled
              ? "bg-gray-400 text-white cursor-not-allowed"
              : "bg-slate-950 hover:bg-slate-500 text-white"
          }`}
        >
          {disabled ? `Resend in ${timer}s` : "Resend Email"}
        </LoadingButton>
        <p className="text-center mt-2">
          I have received the credentials.{" "}
          <span
            onClick={() => navigate("/auth")}
            className="underline text-indigo-800 cursor-pointer"
          >
            Login
          </span>
        </p>
        <AlertModal
          isOpen={modalOpen}
          title={title}
          message={modalMessage}
          isOneButton={true}
          isSuccess={isSuccess}
          onSuccessOneButton={() => {
            setModalOpen(false);
            setTimer(timerDuration);
            setDisabled(true);
            setSubmitting(false);
          }}
        />
      </div>
    </div>
  );
};

export default EmailSentPage;
